// @ts-nocheck
(function () {
  'use strict';
  window.AIFlorist = window.AIFlorist || {};

  var FIRST_TOUCH_KEY = 'aiflorist_attr_first_touch_v1';
  var LAST_TOUCH_KEY = 'aiflorist_attr_last_touch_v1';

  function capture() {
    var state = refreshAttributionState();
    var merged = mergeAttribution(state.firstTouch, state.lastTouch);
    merged = mergeAttribution(merged, {
      fbc: state.current.fbc,
      fbp: state.current.fbp,
      ga: state.current.ga,
      gl: state.current.gl,
      landingPage: state.current.landingPage,
      referrer: state.current.referrer,
    });
    if (!merged.fbc && merged.fbclid) {
      merged.fbc = buildFbcFromFbclid(merged.fbclid);
    }
    return merged;
  }

  function captureFirstTouch() {
    return refreshAttributionState().firstTouch;
  }

  function captureLastTouch() {
    return refreshAttributionState().lastTouch;
  }

  function refreshAttributionState() {
    var current = captureCurrent();
    var firstTouch = readStored(FIRST_TOUCH_KEY);
    var lastTouch = readStored(LAST_TOUCH_KEY);

    if (hasAcquisitionSignal(current)) {
      if (!hasAcquisitionSignal(firstTouch)) {
        firstTouch = sanitizeForStorage(current);
      }
      lastTouch = mergeAttribution(lastTouch, sanitizeForStorage(current));
    }

    if (!hasAcquisitionSignal(lastTouch) && hasAcquisitionSignal(firstTouch)) {
      lastTouch = mergeAttribution({}, firstTouch);
    }

    if (hasAcquisitionSignal(firstTouch)) writeStored(FIRST_TOUCH_KEY, firstTouch);
    if (hasAcquisitionSignal(lastTouch)) writeStored(LAST_TOUCH_KEY, lastTouch);

    return {
      current: current,
      firstTouch: firstTouch,
      lastTouch: lastTouch,
    };
  }

  function captureCurrent() {
    var out = {};
    var params = new URLSearchParams(window.location.search || '');

    assignIfPresent(out, 'utmSource', params.get('utm_source'));
    assignIfPresent(out, 'utmMedium', params.get('utm_medium'));
    assignIfPresent(out, 'utmCampaign', params.get('utm_campaign'));
    assignIfPresent(out, 'utmTerm', params.get('utm_term'));
    assignIfPresent(out, 'utmContent', params.get('utm_content'));
    assignIfPresent(out, 'gclid', params.get('gclid'));
    assignIfPresent(out, 'gbraid', params.get('gbraid'));
    assignIfPresent(out, 'wbraid', params.get('wbraid'));
    assignIfPresent(out, 'fbclid', params.get('fbclid'));
    assignIfPresent(out, 'msclkid', params.get('msclkid'));
    assignIfPresent(out, 'ttclid', params.get('ttclid'));
    assignIfPresent(out, 'fbp', readCookie('_fbp'));
    assignIfPresent(out, 'fbc', readCookie('_fbc'));
    assignIfPresent(out, 'ga', readCookie('_ga'));
    assignIfPresent(out, 'gl', readCookie('_gl'));
    assignIfPresent(out, 'landingPage', (window.location.pathname || '/') + (window.location.search || ''));
    assignIfPresent(out, 'referrer', document.referrer || '');

    if (!out.fbc && out.fbclid) {
      out.fbc = buildFbcFromFbclid(out.fbclid);
    }
    return out;
  }

  function sanitizeForStorage(input) {
    var out = {};
    if (!input) return out;
    assignIfPresent(out, 'utmSource', input.utmSource);
    assignIfPresent(out, 'utmMedium', input.utmMedium);
    assignIfPresent(out, 'utmCampaign', input.utmCampaign);
    assignIfPresent(out, 'utmTerm', input.utmTerm);
    assignIfPresent(out, 'utmContent', input.utmContent);
    assignIfPresent(out, 'gclid', input.gclid);
    assignIfPresent(out, 'gbraid', input.gbraid);
    assignIfPresent(out, 'wbraid', input.wbraid);
    assignIfPresent(out, 'fbclid', input.fbclid);
    assignIfPresent(out, 'msclkid', input.msclkid);
    assignIfPresent(out, 'ttclid', input.ttclid);
    assignIfPresent(out, 'fbc', input.fbc);
    assignIfPresent(out, 'fbp', input.fbp);
    assignIfPresent(out, 'ga', input.ga);
    assignIfPresent(out, 'gl', input.gl);
    assignIfPresent(out, 'landingPage', input.landingPage);
    assignIfPresent(out, 'referrer', input.referrer);
    return out;
  }

  function mergeAttribution(base, incoming) {
    var out = {};
    var keys = [
      'utmSource', 'utmMedium', 'utmCampaign', 'utmTerm', 'utmContent',
      'gclid', 'gbraid', 'wbraid', 'fbclid', 'msclkid', 'ttclid',
      'fbc', 'fbp', 'ga', 'gl', 'landingPage', 'referrer'
    ];
    var i;
    for (i = 0; i < keys.length; i++) {
      var key = keys[i];
      if (base && base[key]) out[key] = base[key];
    }
    for (i = 0; i < keys.length; i++) {
      var inKey = keys[i];
      if (incoming && incoming[inKey]) out[inKey] = incoming[inKey];
    }
    return out;
  }

  function hasAcquisitionSignal(attr) {
    if (!attr) return false;
    return !!(
      attr.utmSource ||
      attr.utmMedium ||
      attr.utmCampaign ||
      attr.utmTerm ||
      attr.utmContent ||
      attr.gclid ||
      attr.gbraid ||
      attr.wbraid ||
      attr.fbclid ||
      attr.msclkid ||
      attr.ttclid ||
      attr.fbc ||
      attr.fbp
    );
  }

  function readStored(key) {
    try {
      var raw = localStorage.getItem(key);
      if (!raw) return {};
      var parsed = JSON.parse(raw);
      if (!parsed || typeof parsed !== 'object' || Array.isArray(parsed)) return {};
      return sanitizeForStorage(parsed);
    } catch (_err) {
      return {};
    }
  }

  function writeStored(key, value) {
    try {
      if (!value || typeof value !== 'object') return;
      localStorage.setItem(key, JSON.stringify(sanitizeForStorage(value)));
    } catch (_err) {
      // Ignore storage failures (private mode, quota, etc).
    }
  }

  function assignIfPresent(target, key, value) {
    if (!value) return;
    var trimmed = String(value).trim();
    if (!trimmed) return;
    target[key] = trimmed;
  }

  function readCookie(name) {
    var source = String(document.cookie || '');
    if (!source) return '';
    var prefix = name + '=';
    var parts = source.split(';');
    for (var i = 0; i < parts.length; i++) {
      var part = parts[i].trim();
      if (part.indexOf(prefix) !== 0) continue;
      return decodeURIComponent(part.slice(prefix.length));
    }
    return '';
  }

  function buildFbcFromFbclid(fbclid) {
    var ts = Math.floor(Date.now() / 1000);
    return 'fb.1.' + ts + '.' + String(fbclid).trim();
  }

  window.AIFlorist.attribution = {
    capture: capture,
    captureFirstTouch: captureFirstTouch,
    captureLastTouch: captureLastTouch,
  };
})();
